import React, { Component } from 'react';

import {
  MDBCard,
  MDBIcon,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
  MDBLink,
} from 'mdbreact';

import LocationSearch from "./LocationSearch";

/** import config **/
import config from '../../../config';

/** import styles **/
import '../../../assets/css/sections/location.css';


class LocationOverview extends Component {

  constructor(props) {
    super(props);
    this.state = {
      modal: false
    }

    this.sectionRef = React.createRef();
  }

  render() {
    return (
      <section id="location-overview" ref={this.sectionRef}>
        <MDBCard className="card-location">
          <MDBCardBody>
            <MDBCardTitle><MDBIcon icon="globe mr-2" /> Location</MDBCardTitle>
            <MDBCardText tag="div">
              <LocationSearch overviewComponent={this} />
            </MDBCardText>
          </MDBCardBody>
        </MDBCard>
      </section>
    );
  }
}

export default LocationOverview;
